// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const clickable = "SavingsMonthly__clickable__NIRbz";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const savingMonthly = "SavingsMonthly__savingMonthly__WSaXr";
export const semibold = "600";
export const serif = "'serif'";